// extracted by mini-css-extract-plugin
module.exports = {"container":"AccessoriesList_container__QvlPG","itemsContainer":"AccessoriesList_itemsContainer__Oq_Qr","title":"AccessoriesList_title__K3uLy"};